import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "NEMA_6-20R",
  "use": "NEMA_6-20R-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"NEMA_6-20R\"><path d=\"M20 38.5c10.217 0 18.5-8.283 18.5-18.5S30.217 1.5 20 1.5 1.5 9.783 1.5 20 9.783 38.5 20 38.5zm0 1.5C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zM16.5 6.5V13a3.5 3.5 0 007 0V6.5h-7zM15 5h10v8a5 5 0 01-10 0V5zm18.5 19.5v2h-5v4h-3v-10h3v4h5zM30 23v-4h-6v13h6v-4h5v-5h-5zm-23.5.5v2h8v-2h-8zM5 22h11v5H5v-5z\" fill=\"#000\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol